
export enum UserOutBidWsEventResponseDtoDataReason {
  OUTBID_BY_BID= 'OUTBID_BY_BID',
  OUTBID_BY_AUTOBID_BID= 'OUTBID_BY_AUTOBID_BID',
  OUTBID_BY_AUTOBID_BID_TIE= 'OUTBID_BY_AUTOBID_BID_TIE',

}